import { Team, UserInfo } from "../Global/types";

export const getPercentageOfCompanyWithManualTeams = (
  usersById: Record<string, UserInfo>,
  teamsById: Record<string, Team>
) => {
  const allUsers = Object.values(usersById);
  const allUsersInManualTeams: number[] = [];

  Object.values(teamsById).forEach((team) => {
    if (!team.isAutomatic || !team?.teamMemberIds) {
      return;
    }
    allUsersInManualTeams.push(...team.teamMemberIds);
  });

  const uniqueUsersInManualTeams = new Set(allUsersInManualTeams);

  return Math.round((uniqueUsersInManualTeams.size / allUsers.length) * 100);
};
